<template>
  <sl-vue-tree
    ref="folderTree"
    v-model="folders"
    @nodeclick="nodeClickHandler"
    @toggle="highlightSelected"
  >
    <template v-slot:title="{ node }">
      <span class="node-folder" @touchstart="folderHandler($event)">
        <span
          :class="{ isSelected: node.data.id === folderId }"
          v-track="`folder-tree-${node.data.id}`"
        >
          <v-icon style="font-size:20px;">
            {{
              node.children.length && node.isExpanded
                ? "mdi-folder-open"
                : "mdi-folder"
            }}
          </v-icon>
          <span
            class="pl-1 node-data"
            :class="{
              'text-capitalize': node.data.id === null
            }"
          >
            <div
              :data-node-id="node.data.id"
              :data-node-title="node.title"
              :data-show-info="node.data.showInfo"
              :class="{
                'hover-active': node.isDraggable && node.data.id == null
              }"
            >
              {{ node.title }}
            </div>
          </span>
        </span>
      </span>
    </template>

    <template v-slot:toggle="{ node }">
      <v-icon
        transition
        class="mr-1"
        v-track="'folder-menu-toggle'"
        @click="toggleHandler(node)"
        :style="node.children.length ? '' : 'visibility:hidden'"
      >
        {{ node.isExpanded ? "mdi-menu-down" : "mdi-menu-right" }}
      </v-icon>
    </template>
  </sl-vue-tree>
</template>
<script>
/**
 * A genric component to show Folder in tree format
 * @author Rahul Rawat
 */
import SlVueTree from "sl-vue-tree";
import { $folders } from "@/services";
export default {
  name: "BasicFolderTree",
  emits: ["changeFolder"],
  components: {
    SlVueTree
  },
  props: {
    folderType: {
      type: String
    },
    folderName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      folderId: null,
      ancestryNames: {},
      items: [],
      folders: [],
      expanded: [],
      selectedFolderId: null
    };
  },
  watch: {
    folderId(newId) {
      this.$emit("changeFolder", newId);
      if (this.folderId) {
        const selectedItem = this.items.filter(
          item => item.id === this.folderId
        );
        if (selectedItem.length > 0 && selectedItem[0].ancestry)
          this.expandSelectedFolder(
            selectedItem[0].ancestry.split("/"),
            this.folders[0]
          );
      }
      this.highlightSelected();
      this.selectedFolderId = this.folderId;
    },
    items() {
      this.folders = this.flattenNodes();
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    folderHandler(event) {
      event.returnValue = false;
    },
    expandSelected() {
      const selectedItem = this.items.filter(item => item.id === this.folderId);
      if (selectedItem.length > 0) {
        if (selectedItem[0].ancestry) {
          const items = selectedItem[0].ancestry
            .split("/")
            .map(item => parseInt(item));
          this.expanded = [...items, ...this.expanded];
        }
      }
    },
    highlightSelected() {
      this.$nextTick(() => {
        /* Note: Removed the highlight if any left. */
        const selectedNode = document.getElementsByClassName("selected-node");
        if (selectedNode.length) {
          for (var i = 0; i < selectedNode.length; i++) {
            selectedNode[i].classList.remove("selected-node");
          }
        }
        /* Note: Highlight the selected folder.
                   If none is selected, select the root folder.
           */
        if (!this.folderId) {
          this.updateAncestry({});
          document
            .getElementsByClassName("sl-vue-tree-node-item")[0]
            .classList.add("selected-node");
        } else {
          document.getElementsByClassName("isSelected")[0] &&
            document
              .getElementsByClassName("isSelected")[0]
              .parentNode.parentNode.parentElement.classList.add(
                "selected-node"
              );
        }
      });
    },
    expandSelectedFolder(ids, parent) {
      let path = [0];
      for (let i = 0; i < ids.length; i++) {
        const index = parent.children.findIndex(item => item.data.id == ids[i]);
        if (index != -1) {
          path.push(index);
          this.$refs.folderTree.updateNode(path, { isExpanded: true });
          const expandIndex = this.expanded.indexOf(
            parent.children[index].data.id
          );
          if (expandIndex === -1) {
            this.expanded.push(expandIndex);
          }
          parent = parent.children[index];
        }
      }
    },
    /**
     * handle node click
     * @param {Object} item - folder item
     */
    nodeClickHandler(item) {
      this.selectedFolderId = item.data.id;

      this.folderId = this.selectedFolderId;
      const index = this.items.findIndex(node => node.id == item.data.id);
      this.updateAncestry({ ...this.items[index] });
      this.highlightSelected();
    },
    updateAncestry(items) {
      const ancesters = [];
      if (items.ancestry) {
        const ancester_ids = items.ancestry.split("/");
        for (let i = 0; i < ancester_ids.length; i++) {
          const obj = {
            text: this.ancestryNames[ancester_ids[i]],
            id: ancester_ids[i]
          };
          ancesters.push(obj);
        }
      }
      items.id && ancesters.push({ text: items.name, id: items.id });
    },
    flattenNodes() {
      const items = this.items.filter(item => {
        if (item.ancestry !== null) return false;
        const owner_access = item.is_owner;
        const editor_access = item.is_editor;
        item.isExpanded = this.expanded.indexOf(item.id) > -1;
        item.title = item.name;
        item.isSelectable = owner_access || editor_access;
        item.isSelected = item.id === this.folderId;
        item.isDraggable = false;
        item.data = {
          id: item.id,
          parent_id: null,
          edit: false,
          owner_access: owner_access,
          editor_access: editor_access,
          ancestry: item.ancestry,
          showInfo:
            item.data &&
            (item.data.hasOwnProperty("showInfo") ? item.data.showInfo : false)
        };
        if (item.owner_access || item.editor_access) {
          item.children = this.traverse(item.id);
        }
        return item;
      });
      return [
        {
          data: {
            id: null,
            parent_id: null,
            edit: false,
            showInfo: false
          },
          isDraggable: false,
          title: "My " + this.folderName + "s",
          children: items,
          isSelected: !this.folderId
        }
      ];
    },
    traverse(ancestor) {
      this.ancestryNames = {};
      return this.items.filter(node => {
        this.ancestryNames[node.id] = node.name;

        if (node.ancestry === null) {
          return false;
        }
        const owner_access = node.is_owner;
        const editor_access = node.is_editor;
        let parent_id = null;
        if (node.ancestry) {
          const temp = node.ancestry ? node.ancestry.split("/") : [];
          parent_id = parseInt(temp[temp.length - 1]);
        }
        if (parent_id === ancestor) {
          node.isExpanded = this.expanded.indexOf(node.id) > -1;
          node.title = node.name;
          node.isSelectable = owner_access || editor_access;
          node.isSelected = node.id === this.folderId;
          node.isDraggable = false;
          node.data = {
            id: node.id,
            parent_id: parent_id,
            edit: false,
            owner_access: owner_access,
            editor_access: editor_access,
            ancestry: node.ancestry,
            showInfo:
              node.data &&
              (node.data.hasOwnProperty("showInfo")
                ? node.data.showInfo
                : false)
          };
          node.children = this.traverse(node.id);
          return node;
        }
      });
    },
    toggleHandler(node) {
      const mainFolder =  "My " + this.folderName + "s";
      if (node.title != mainFolder) {
        const index = this.expanded.indexOf(node.data.id);
        if (index > -1) {
          this.expanded.splice(index, 1);
        } else {
          this.expanded.push(node.data.id);
        }
      }
    },
    fetch() {
      $folders
        .fetch({
          params: {
            folderType: this.folderType
          }
        })
        .then(response => {
          this.items = response.data.data.folders;
          this.expandSelected();
          this.highlightSelected();
        });
    }
  }
};
</script>
